import { extractSearchFormData, serializeFormData } from 'js/tools';

const apiConnector = {
    /**
     * Keep track of most recent requests
     */
    searchFacetsXhr: null,
    searchResultsXhr: null,

    /**
     * Fetch facets based on serialized form data and fires success/error callback
     * @param config
     */
    getSearchFacets: config => {
        if (apiConnector.searchFacetsXhr) {
            apiConnector.searchFacetsXhr.abort();
        }

        const elm = document.querySelector('[data-search-facets-api]');
        const url = elm.getAttribute('data-search-facets-api') || '/api/client/search/facets';
        const serializedData = apiConnector.getSerializedData(config);

        apiConnector.searchFacetsXhr = apiConnector.createXhr(url, config.success, config.error);
        apiConnector.searchFacetsXhr.send(serializedData);
    },

    /**
     * Fetch results based on serialized form data and fires success/error callback
     * @param config
     */
    getSearchResults: config => {
        if (apiConnector.searchResultsXhr) {
            apiConnector.searchResultsXhr.abort();
        }

        const elm = document.querySelector('[data-search-results-api]');
        const url = elm.getAttribute('data-search-results-api') || '/api/client/search/results';
        const serializedData = apiConnector.getSerializedData(config);

        apiConnector.searchResultsXhr = apiConnector.createXhr(url, config.success, config.error);
        apiConnector.searchResultsXhr.send(serializedData);
    },

    /**
     * Returns prepared XMLHttpRequest
     * @param url
     * @param successHandler
     * @param errorHandler
     * @return xhr
     */
    createXhr: (url, successHandler, errorHandler) => {
        const xhr = new XMLHttpRequest();

        xhr.open('POST', url, true);
        xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

        xhr.onload = () => {
            if (xhr.status === 200) {
                successHandler(xhr);
            } else {
                errorHandler(xhr);
            }
        };

        return xhr;
    },

    /**
     * Returns serialized form data based on api call configuration.
     * @param config
     * @returns {*}
     */
    getSerializedData: config => {
        let serializedData = '';

        if (config.serializedData) {
            ({ serializedData } = config);
        } else if (config.formReference) {
            const formData = extractSearchFormData(config.formReference);

            serializedData = serializeFormData(formData);
        }

        return serializedData;
    }
};

export default apiConnector;
